import { useLocation } from 'react-router-dom';
import { LogoMark } from '@/components/BrandLogo';
import { accentForPath } from '@/lib/pageTheme';

// Sayfa (lazy chunk) yüklenirken gösterilen yer tutucu.
//
// ARKA PLAN YOK — bilerek. Zemin, SiteLayout'un rotadan belirlediği sabit
// `--page-bg` katmanından gelir (bkz. pageTheme.ts); sayfa yüklenince onun
// kendi *Backdrop bileşeni devralır. Yükleyiciye ızgara/ışıma eklemek bu
// tasarımın ÜZERİNE ikinci bir katman bindiriyordu; kaldırıldı.
//
// Renk sayfadan gelir: açılmakta olan rotanın vurgu rengi (bkz. pageTheme.ts)
// kullanılır, böylece yükleme efekti o sayfanın tasarım diliyle aynı tonda
// belirir — Terminal'de turuncu, BistLab'de teal, Eklem'de yeşil...

const KEYFRAMES = `
  @keyframes ktp-loader-pulse { 0%,100% { opacity: .32; transform: scale(0.96); } 50% { opacity: .78; transform: scale(1); } }
  @keyframes ktp-loader-sweep { 0% { transform: translateX(-100%); } 100% { transform: translateX(300%); } }
  @media (prefers-reduced-motion: reduce) {
    .ktp-loader-mark, .ktp-loader-sweep { animation: none !important; }
  }
`;

const PageLoader = ({
  /** Navbar (h-20) akışta yer kapladığı için varsayılan yükseklik onu düşer. */
  full = false,
  /** Sayfa İÇİNDEKİ bir bölüm yüklenirken (hero zaten görünür) — tam ekran
      yükseklik burada gereksiz büyük boşluk bırakırdı. */
  compact = false,
  /**
   * Hero'su navbar'ın ALTINA giren sayfalar için (-mt-20 kullananlar: Home ve
   * Kurumsal). Yer tutucu da aynı hizada başlar.
   *
   * Olmazsa: yer tutucu navbar'ın altında (y=80) başlar, sayfa gelince hero
   * y=0'a çıkar ve içerik ~80px yukarı SIÇRAR.
   */
  edgeToEdge = false,
  /** Rotadan türetilen rengi ezmek için (nadiren gerekir). */
  accent,
}: {
  full?: boolean;
  compact?: boolean;
  edgeToEdge?: boolean;
  accent?: string;
}) => {
  const { pathname } = useLocation();
  const color = accent ?? accentForPath(pathname);

  return (
    <div
      // data-page-loading: IntroSplash perdeyi bu işaret kalkmadan kaldırmaz —
      // açılışta navbar altında boş alan görünmesin (bkz. SiteLayout).
      // Kompakt hâlde İŞARET KONMAZ: sayfa zaten görünür durumda, perdeyi
      // bekletmek gereksiz olurdu.
      data-page-loading={compact ? undefined : true}
      role="status"
      aria-busy="true"
      className={`relative flex w-full items-center justify-center ${
        compact
          ? 'min-h-[50vh]'
          : full || edgeToEdge
            ? 'min-h-[100lvh]'
            : 'min-h-[calc(100lvh-5rem)]'
      } ${edgeToEdge ? '-mt-20' : ''}`}
    >
      <style>{KEYFRAMES}</style>

      <div className="flex flex-col items-center gap-6">
        {/* Nefes alan Kapsül amblemi — sayfanın vurgu renginde.
            (Animasyon saran öğede: LogoMark yalnızca className alır.) */}
        <span
          className="ktp-loader-mark block"
          style={{
            color,
            animation: 'ktp-loader-pulse 1.8s ease-in-out infinite',
          }}
        >
          <LogoMark className="h-14 w-auto sm:h-16" />
        </span>

        {/* İnce ilerleme şeridi — üzerinde sayfanın renginde ışık gezer */}
        <span
          aria-hidden
          className="relative block h-px w-28 overflow-hidden rounded-full bg-white/10"
        >
          <span
            className="ktp-loader-sweep absolute inset-y-0 left-0 w-1/3 rounded-full"
            style={{
              background: `linear-gradient(90deg, transparent, ${color}, transparent)`,
              animation: 'ktp-loader-sweep 1.4s ease-in-out infinite',
            }}
          />
        </span>
      </div>
    </div>
  );
};

export default PageLoader;
